<template>
    <div style="display:flex;height:100%;">
        <div class="left-tree">
            <div style="background:#4A4C4F;padding:10px 5px;">
                <span>站点导航</span>
                <i class="el-icon-search" @click="showSearch" style="padding-left:15px;" v-if="!isFold"></i>
                <span style="display:inline-block;" @click="toggle">
                    <i :class="[isFoldClass]"></i>
                </span>
            </div>
            <el-input v-if="showSearchBox" clearable
                placeholder="输入关键字进行过滤"
                v-model="filterText">
            </el-input>
            <div class="tree-div">
                <tree :type="'site'" :data="treeData"
                  @clickNode="clickNode"
                  @clickMark="clickMark"
                  :currentKey="currentKey"
                  :isDefaultExpandFirst = "isDefaultExpandFirst"
                  ref="trees"
                  v-if="treeData.length!=0"></tree>
            </div>
        </div>
        <div class="main-area">
            <div class="sub-tabs site-tabs">
                <div>
                    <button class="small-btn" @click="showDialog(2)">实时</button>
                    <button class="small-btn" @click="showDialog(1)">趋势</button>
                    <button class="small-btn" @click="handleSelectAll(3)">全选</button>
                </div>
                <el-tabs v-model="activeTab" class="site-tabs-ul">
                    <!-- <el-tab-pane label="一次接线图" name="chart"></el-tab-pane> -->
                    <el-tab-pane label="测点列表" name="list"></el-tab-pane>
                </el-tabs>
            </div>
            <div v-if="activeTab == 'list'" style="height:calc(100% - 50px);">
                <div class="search-content">
                <el-form ref="form" :model="form" label-width="80px" class="site-form">
                    <el-col :span="18">
                        <el-col :span="12">
                            <el-form-item label="测点名称" prop="point_name">
                                <el-input v-model="form.point_name"  placeholder="请输入关键字" clearable style="width:217px;"  :class="{ 'selected-border': form.point_name }"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="报警状态"  prop="alarm_level">
                                <el-select v-model="form.alarm_level" placeholder="请选择" clearable  popper-class="dark-style" :class="{ 'selected-border': form.alarm_level }">
                                    <el-option label="正常" value="0"></el-option>
                                    <el-option label="诊断预警" value="1"></el-option>
                                    <el-option label="诊断报警" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作状态" prop="is_online" :class="{ 'selected-border': form.is_online }">
                                <el-select v-model="form.is_online" placeholder="请选择" clearable popper-class="dark-style">
                                    <el-option label="在线" value="true"></el-option>
                                    <el-option label="离线" value="false"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="传感器类型" prop="sensor_type" :class="{ 'selected-border': form.sensor_type }">
                                <el-select v-model="form.sensor_type" placeholder="请选择" clearable popper-class="dark-style">
                                    <el-option v-for="item in sensorTypeList" :label="item.label" :value="item.type" :key="item.type"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item size="large">
                            <el-button class="small-btn" @click="queryData">查询</el-button>
                            <el-button class="small-btn" @click="doReset">重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div class="table-content"                                     
                @mousedown="startLongPress"
                @mouseup="endLongPress"  
                @mouseleave="endLongPress" 
                @touchstart="startLongPress" 
                @touchend="endLongPress">
                <el-table :data="tableData"
                    highlight-current-row
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    @select--all="handleSelectAll"
                    row-key="id"
                    :reserve-selection="true"
                    :cell-style="setRowColor"
                    v-loading="loading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)" ref="multipleTable">
                    <el-table-column
                        header-align="center"
                        align="center"
                        type="selection" :selectable="selectFun"
                        width="55"
                    ></el-table-column>
                    <el-table-column label="序号" align="center" type="index" width="50"></el-table-column>
                    <el-table-column prop="equipment_name" align="center" label="设备名称" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="sensor_number" align="center"  label="绑定传感器编号" min-width="180" show-overflow-tooltip v-if="showSensorId"></el-table-column>
                    <el-table-column prop="point_name" align="center"  label="测点名称" min-width="180" show-overflow-tooltip>
                        <template slot-scope="props">
                            <div class="status-container">
                            <!-- 趋势状态图标 -->
                                <div class="status-header">
                                    <img 
                                        style="width: 28px;height: 25px;" 
                                        src="@/assets/trend_expect.png" 
                                        alt="趋势异常"
                                        :class="{ 'intermittent-shake': isHasTrendAlarm(props.row) }"
                                        v-if="isHasTrendAlarm(props.row)">
                                    <span class="online-text">{{ props.row.point_name}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sensor_type" align="center"   label="传感器类型"  min-width="150">
                        <template slot-scope="props">
                            <p>{{getLabel(props.row.sensor_type)}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column 
                    prop="battery" 
                    align="center" 
                    label="工作状态"  
                    show-overflow-tooltip  
                    min-width="180"
                    >
                        <template slot-scope="props">
                            <!-- 统一容器，便于控制整体样式 -->
                            <div class="status-container">
                            <!-- 在线状态图标 -->
                                <div class="status-header">
                                    <img 
                                    class="status-icon" 
                                    :src="getSensorStatusIcon(props.row.is_online)" 
                                    :alt="props.row.is_online ? '在线图标' : '离线图标'"
                                    >
                                    <span class="online-text">{{ props.row.is_online ? '在线' : '离线' }}</span>
                                </div>

                            
                                <!-- 电池、RSSI、SNR 信息（按传感器类型区分显示） -->
                                <div class="metrics-info" >
                                    <!-- 非TEMP类型：显示电池百分比、RSSI、SNR图标+文本 -->
                                    <template v-if="props.row.sensor_type !== 'TEMP'">
                                        <div class="metric-item" v-if="props.row.battery !== undefined && props.row.battery !== ''">
                                            <img src="@/assets/battery.png" alt="电池图标" class="metric-icon">
                                            <span>{{ props.row.battery}}%</span>
                                        </div>
                                        <div class="metric-item" v-if="props.row.rssi !== undefined && props.row.rssi !== ''">
                                            <img src="@/assets/rssi.png" alt="RSSI图标" style="width:13px;height:13px">
                                            <span>{{ props.row.rssi }}dBm</span>
                                        </div>
                                        <div class="metric-item" v-if="props.row.snr !== undefined && props.row.snr !== ''">
                                            <img src="@/assets/snr.png" alt="SNR图标" class="metric-icon">
                                            <span>{{ props.row.snr }}dB</span>
                                        </div>
                                    </template>
                                    
                                    <!-- TEMP类型：显示电池电压、RSSI、SNR文本 -->
                                    <template v-else>
                                        <!--<div class="metric-item" v-if="props.row.rssi !== undefined">
                                            <img src="@/assets/rssi.png" alt="RSSI图标" style="width:13px;height:13px">
                                            <span>{{ props.row.rssi }}dBm</span>
                                        </div>-->
                                        <div class="metric-item" v-if="props.row.battery !== undefined && props.row.battery !== ''">
                                            <img src="@/assets/battery_v.png" alt="SNR图标" class="metric-icon">
                                            <span>{{ (props.row.battery == 0 ? 0 : props.row.battery/1000).toFixed(2) }}V</span>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="alarm_describe" align="center" label="报警状态"  show-overflow-tooltip  min-width="140">
                        <template  slot-scope="props">
                            <div class="status-container">
                            <!-- 在线状态图标 -->
                                <div class="status-header">
                                    <img 
                                    class="status-icon" 
                                    :src="getAlarmStatusIcon(props.row.alarm_level)"
                                    v-if="props.row.alarm_level != null"
                                    >
                                    <span class="online-text-alarmStatus">{{alarmLevel[props.row.alarm_level]}}</span>
                                </div>
                            </div>
                           <div  v-if="props.row.has_sensor_data">
                                <img class="sensor_status"  />
                                <p class="alarmLevel_p">   
                                    </p>  <!-- alarmLevel[props.row.alarm_level] -->
                                <p>{{'描述:'+(alarmDescribeDict[props.row.alarm_describe] || '---')}}</p>
                           </div>
                           <div v-else>
                            {{ '--' }}
                           </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="character_value" align="center"  label="特征值"  min-width="200" show-overflow-tooltip>
                        <template slot-scope="props">
                            <div v-if="props.row.has_sensor_data">
                                <span v-if="props.row.sensor_type=='MECH'">{{characteristicValue[props.row.sensor_type].name+mechState[props.row.character_value]}}</span>
                                <span v-else-if="props.row.sensor_type=='MECHSEP'">{{(characteristicValue[props.row.sensor_type].name)}}{{(mechsepState[props.row.character_value])}}</span>
                                <span v-else>{{characteristicValue[props.row.sensor_type].name+ toFixedEnhance(props.row.character_value||0, 2) }}</span>
                                <span v-if="props.row.sensor_type!='TEMP'">{{ sensorType[props.row.unit] }}</span>
                                <span v-else> °C</span>
                            </div>
                            <div v-else>{{ '--' }}   </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="upload_interval" align="center" label="上传间隔" min-width="85" show-overflow-tooltip>
                        <template slot-scope="props">
                            <p  v-if="props.row.sensor_type!='MECH' && props.row.upload_interval">{{(props.row.upload_interval/60).toFixed(2) + 'min'}}</p>
                            <P v-else>--</P>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_date" align="center" min-width="150" label="更新时间" show-overflow-tooltip>
                        <template slot-scope="props">
                           {{ props.row.create_date || '--' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="100">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="details(scope.row)" :disabled="!scope.row.has_sensor_data">查看</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5,10, 20, 50]"
                    prev-text="上一页" next-text="下一页"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
            </div>
            <div v-if="activeTab == 'chart'" id="bigimg" style="text-align:center;position:relative;">
                <img ref="bigImage" src="../../assets/3.svg"  @mousewheel="bagimg(this)"  @mousedown="move($event)"  alt="" style="position:relative;">
                <!-- <embed type="image/svg+xml" src="../../assets/1.svg" id="my-embed"/>            -->
            </div>
        </div>
        <div  v-if="showChart">
             <chart :visible.sync="showChart"
              :tableData="tableData"
              :selectData="selectData"
              :total="total"
              :currentNode="currentNode"></chart>
        </div>
        <div  v-if="showChartDetails" >
            <chartDetails  :visible.sync="showChartDetails" :dataDetails="dataDetails"></chartDetails>
        </div>
        <div  v-if="showjx" >
            <jx  :visible.sync="showjx" :dataDetails="dataDetails"></jx>
        </div>
        <div v-if="showNearestMotorSeq">
           <NearestMotorSeq :visible.sync="showNearestMotorSeq" :dataDetails="dataDetails"></NearestMotorSeq>
        </div>
    </div>
</template>

<script>
import * as device from '@/data/device.js'
import tree from '@/components/tree.vue'
import NearestMotorSeq from "./components/NearestMotorSeq/NearestMotorSeqDialog.vue"
import Bus from "@/util/Bus.js";
import {sensorType, sensorTypeOptions, characteristicValue, alarmDescribeDict, alarmLevel} from "@/util/sensorType.js"
export default {
    name: "",
    components:{
        tree,
        chart:resolve => {require(['../site/chart.vue'], resolve)},
        chartDetails:resolve => {require(['../site/chartDetails.vue'], resolve)},
        jx:resolve => {require(['../site/jx.vue'], resolve)},
        NearestMotorSeq
    },
    data() {
        return {
            userInfo:JSON.parse(localStorage.getItem('userInfo')),
            isFold:false,
            isFoldClass:'el-icon-s-fold',
             showChart:false,
             showChartDetails:false,

             isDefaultExpandFirst: true,
             treeData:[],
            tableData: [] ,
            selectData:[],
            originTableData:[],
            form: {
                point_name: '',
                is_online: '',
                alarm_level: '',
                sensor_type: '',
            },
            activeTab:'list',
            dataDetails:{},
            selectedData:[], // 表格中选中的数据
            params:{
                zoomVal:1,left:0,top:0,currentX:0,currentY:0,flag:false,
            },
            filterText:'',
            showSearchBox:false,
             currentPage:1,
            size:10,
            total:0,
            currentNode:{},//操作分页组件时需要知道之前点击的是哪个node
            loading:false,
            showjx: false,
            showNearestMotorSeq:false,
            alarmLevel,
            currentKey: '',//树的当前高亮点
            characteristicValue,
            mechState: ['-', '分闸', '合闸'],
            mechsepState:['-','分闸','合闸','分闸','分合','分合','分合分','分合分'],
            sensorType,
            sensorTypeList: sensorTypeOptions,
            alarmDescribeDict,
            maxSelectionLimit: 6,
            isSelectAll: false,
            pressTimer: null,  // 定时器ID
            isLongPress: false, // 是否触发了长按
            showSensorId: false
        };
    },
    watch: {
      filterText(val) {
        this.$refs.trees.filterData(val);
        },
    },
    mounted() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
            // 假设 getTreeData 是异步操作（如接口请求），用 await 等待完成
            this.getTreeData();
            Bus.$on('wsData', this.wsDataBySite)
        } catch (error) {
            // 可添加错误提示：this.$message.error('加载失败，请重试')
        } finally {
            // 无论成功/失败，最终都关闭 loading
            if (loading && typeof loading.close === 'function') {
            loading.close();
            }
        }
    },
    beforeDestroy() {
        // 注销事件监听器
        Bus.$off('wsData', this.wsDataBySite);
    },
    methods: {
        isHasTrendAlarm(data) {
            const has_trend_warning = data.long_trend_warning || data.short_trend_warning
            const has_trend_alarm = data.long_trend_alarm || data.short_trend_alarm
            if (has_trend_alarm) {
                return 'label-name-red'
            } else if (has_trend_warning) {
                return 'label-name-yellow'
            } else {
                return false
            }
        },
        setRowColor({row}) {
            const has_trend_warning = row.long_trend_warning || row.short_trend_warning
            const has_trend_alarm = row.long_trend_alarm || row.short_trend_alarm
            if (has_trend_alarm) {
                return {
                    color: 'rgba(233, 86, 86, 1)'
                }
            } else if (has_trend_warning) {
                return {
                    color: 'rgba(249, 229, 129, 1)'
                }
            }else {
                return {
                    color: '#ffffff'
                }
            }
        },
        // 开始按下时触发
        startLongPress() {
        // 清除之前的定时器（防止重复触发）
        clearTimeout(this.pressTimer);
        
        // 设置定时器，300ms后判定为长按（可自定义时长）
        this.pressTimer = setTimeout(() => {
            this.isLongPress = true;
            this.showSensorId = !this.showSensorId
            // 这里写长按后的逻辑（如弹出菜单、删除操作等）
        }, 1000 * 5); // 时长可调整（单位：毫秒）
        },
        
        // 结束按下时触发
        endLongPress() {
            // 清除定时器，避免未达到长按时间却触发
            clearTimeout(this.pressTimer);
            // 重置状态
            this.isLongPress = false;
        },
        getSensorStatusIcon(sensorStatus) {
           return sensorStatus 
            ? require('../../assets/light_comm.png')   // 在线状态图片
            : require('../../assets/light_alarm.png'); // 离线状态图片 
        },
        getAlarmStatusIcon(alarmStatus) {
            if (alarmStatus === 0) {
                return require('../../assets/light_comm.png')
            }else if (alarmStatus === 1) {
                return require('../../assets/light_warnning.png')
            }else if (alarmStatus === 2) {
                return require('../../assets/light_alarm.png')
            }
        },
        wsDataBySite(target){
            target = JSON.parse(target);
            let sensorData = target.message.data.sensor_data;
            if(sensorData){
              //根据当前显示的列表做筛选，不是直接变更到列表中
              this.tableData.forEach((item,index) => {
                  if (item.sensor_number == sensorData.sensor_id) {
                      item.sensor_data_id=sensorData.sensor_data_id
                      if(sensorData.hasOwnProperty('is_online'))item.is_online = sensorData.is_online;
                      if(sensorData.hasOwnProperty('battery'))item.battery = sensorData.battery;
                      if(sensorData.hasOwnProperty('rssi'))item.rssi = sensorData.rssi;
                      if(sensorData.hasOwnProperty('snr'))item.snr = sensorData.snr;
                      if(sensorData.hasOwnProperty('alarm_level'))item.alarm_level = sensorData.alarm_level;
                      if(sensorData.hasOwnProperty('alarm_describe'))item.alarm_describe = sensorData.alarm_describe;
                      if(sensorData.hasOwnProperty('has_sensor_data'))item.has_sensor_data = sensorData.has_sensor_data;
                      if(sensorData.hasOwnProperty('character_value'))item.character_value = sensorData.character_value;
                      if(sensorData.hasOwnProperty('unit'))item.unit = sensorData.unit;
                      if(sensorData.hasOwnProperty('upload_interval'))item.upload_interval = sensorData.upload_interval;
                      if(sensorData.hasOwnProperty('create_date'))item.create_date = sensorData.create_date;
                  }
              })
            }
        },
        getLabel(type) {
           return  this.sensorTypeList.filter(item=>item.type==type)[0].label
        },
         handleSizeChange(val){
             this.size = val;
             this.clickNodeTree(this.currentNode)
        },
        handleCurrentChange(val){
            this.currentPage = val;
            this.clickNodeTree(this.currentNode)
        },
        showSearch(){
            this.showSearchBox = !this.showSearchBox ;
        },
        toggle(){
            this.isFold = !this.isFold;
            let style = this.isFold?{width:'25px'}:{width:'280px'}
            let heightStyle = this.isFold?{height:'120px'}:{height:'calc(100% - 160px)'}
            let treeStyle = this.isFold?{height:0}:{height:"calc(100% - 40px)"}
            this.isFoldClass = this.isFold?'el-icon-s-unfold':'el-icon-s-fold'
            $('.left-tree').css(heightStyle).animate(style);
             $('.tree-div').css(treeStyle)
            this.isFold ? $('.main-area').css({ width: '100%' }) : $('.main-area').css({ width: 'calc(100% - 300px)' })
            this.showSearchBox = false
        },
        queryData() {
            this.currentPage = 1
            this.clickNodeTree(this.currentNode)
        },
        doReset(){
            this.currentPage = 1
            this.$refs.form.resetFields();
            this.clickNodeTree(this.currentNode)
            this.restoreSelection()
        },
        handleSelectionChange(val) {
            // 记录当前是否为全选状态
            this.isSelectAll = val.length === this.tableData.length;
            // 当选择数量超过限制时
            if (val.length > this.maxSelectionLimit) {
                this.$nextTick(() => {
                    // 获取最新的选择数据
                    const latestSelection = [...this.$refs.multipleTable.selection];
                    // 截取前maxSelectionLimit个
                    const limitedSelection = latestSelection.slice(0, this.maxSelectionLimit);
                    
                    // 清除所有选择
                    this.$refs.multipleTable.clearSelection();
                    
                    // 重新选择前maxSelectionLimit个
                    limitedSelection.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    });
                    
                    // 更新选中数据
                    this.selectedData = limitedSelection;

                    // 提示用户
                    this.$message.closeAll(); 
                    this.$message.warning(`最多只能选择 ${this.maxSelectionLimit} 个测点`);
                });
            } else {
                // 未超过限制时，直接更新选中数据
                this.selectedData = val;
            }
        },   
        // 手动处理全选按钮点击事件
        handleSelectAll(val) {
            if(val===3){
                 val = this.tableData.slice(0, this.maxSelectionLimit)
                 val.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row,true);
                });
                this.selectedData =  val
                this.$message.warning(`最多只能选择 ${this.maxSelectionLimit} 个测点`);
            } else {
                this.$nextTick(() => {
                    // 如果当前是全选状态（或已选数量达到上限），则取消全选
                    if (this.isSelectAll || this.selectedData.length >= this.maxSelectionLimit) {
                        this.$refs.multipleTable.clearSelection();
                        this.selectedData = [];
                        this.isSelectAll = false;
                    } else {
                        // 否则选中前maxSelectionLimit个
                        const topItems = this.tableData.slice(0, this.maxSelectionLimit);

                        // 清除所有选择
                        this.$refs.multipleTable.clearSelection();

                        // 选择前maxSelectionLimit个
                        topItems.forEach(row => {
                            this.$refs.multipleTable.toggleRowSelection(row, true);
                        });

                        // 更新选中数据
                        this.selectedData = topItems;

                        // 如果数据总数超过限制，提示用户
                        if (this.tableData.length > this.maxSelectionLimit) {
                            this.$message.warning(`最多只能选择 ${this.maxSelectionLimit} 个测点`);
                        }

                        this.isSelectAll = topItems.length === this.tableData.length;
                    }
                });
            } 
        },
        // 无法勾选
        selectFun(row){
            if(!row.has_sensor_data){
                return false;
            }
            return true;
        },
        // 勾选
        handleSelect(val, row) {
            this.selectedData = val;
        },
        getTreeData(){
            let This = this;
            device.queryTree().then(res=>{
                if(!res) return;
                This.treeData = res.data;
                const str = sessionStorage.getItem('currentNode');
                if (this.$route.params.searchForm) {
                    this.form = this.$route.params.searchForm
                }
                //来自综合统计双击进站点详情
                if (this.$route.params.obj) {
                    this.currentKey = this.$route.params.obj.id
                    this.isDefaultExpandFirst = false
                    this.clickNode(this.$route.params.obj)
                }else if (str) {
                    let obj = JSON.parse(str)
                    if(obj.type == 'customer'){
                         obj = obj.children[0]
                    }
                    this.currentKey = obj.id
                    this.isDefaultExpandFirst = false;
                    this.clickNode(obj)
                } else{
                  this.currentKey = res.data[0].children[0].id
                  this.clickNode(res.data[0].children[0])
                }
                this.$nextTick(() => {
                    this.$refs.trees.$refs.tree.setCurrentKey(this.currentKey);
                });
            })
        },
        getEquipmentSensor(id){
            let params = Object.assign({},this.form,{equipments:id,page:this.currentPage,limit:this.size})
            device.queryEquipmentSensor(params).then(res=>{
                this.loading = false;
                if(!res) return;
                this.originTableData = JSON.parse(JSON.stringify(res.data.sensor_list))
                this.tableData = res.data.sensor_list;
                 this.total = res.data.total;
            })
        },
         getSiteSensor(id){
            let params = Object.assign({},this.form,{sites:id,page:this.currentPage,limit:this.size})
            device.querySiteSensor(params).then(res=>{
                this.loading = false;
                if(!res) return;
                this.originTableData = JSON.parse(JSON.stringify(res.data.sensor_list))
                this.tableData = res.data.sensor_list;
                 this.total = res.data.total;
            })
        },
        // 显示实时/趋势
        showDialog(val){
            if(val==1){
                if(!this.selectedData.length) {
                    this.$message({
                        message: '请先选择',
                        type: 'warning'
                    });
                    return;
                }
                // if (this.selectedData.length > 3) {
                //     this.$message('最多可选三条数据');
                //     return;
                // }
                this.selectData = this.selectedData;
                this.showChart = true;
            }else{
                if(!this.selectedData.length) {
                    this.$message({
                        message: '请先选择',
                        type: 'warning'
                    });
                    return;
                }
                //查找是否包含机械特性
                let jxtxIndex = this.selectedData.findIndex(v=>v.sensor_type == 'MECH');
                let nearestMotorSeqIndex = this.selectedData.findIndex(v=>v.sensor_type == 'MECHSEP');
                if(jxtxIndex!=-1){
                  if(this.selectedData.length > 1){
                      this.$message({
                          message: '机械特性不能与其他类型同时选择',
                          type: 'warning'
                      });
                      return;
                  }
                  this.dataDetails = this.selectedData[0];
                  this.showjx = true;
                }else if(nearestMotorSeqIndex!=-1){
                  if(this.selectedData.length > 1){
                      this.$message({
                          message: '机械特性分体传感器不能与其他类型同时选择',
                          type: 'warning'
                      });
                      return;
                  }
                  this.dataDetails = this.selectedData[0];
                  this.showNearestMotorSeq = true;
                }else{
                  this.dataDetails = this.selectedData;
                  this.showChartDetails = true;
                }
            }
        },
        // 树型点击事件
        clickNode(v) {
            this.currentPage = 1
            this.clickNodeTree(v)
            // // 重置
            // this.doReset();
        },
        clickNodeTree(v) {
            this.currentNode = v;
            this.selectedData = [];
            this.currentKey = v.id
            if(v.type=="customer"){
                v = v.children[0]
                // this.$refs.tree && this.$refs.tree.setCurrentKey(v.id);
            }
            if(v.type=="site"){
                this.loading = true;
                this.getSiteSensor(v.id)
            }else if(v.type=="equipment"){
                this.loading = true;
                this.getEquipmentSensor(v.id);
            }
        },
        // 点击mark
        clickMark(node){
            this.$router.replace({ name: 'warning', params: { node: node } });
        },
        getWantedList(data,label){
            let resultArr = [];
            for(var i=0;i<data.length;i++){
                let temp = data[i].children;
                temp.deviceName = label;
                temp.pointName = data[i].label
                resultArr.push(temp)
            }
            return resultArr
        },
        details(row){
            if(row.sensor_type=="MECH"){
                this.dataDetails = row;
                this.showjx = true;
                return;
            }
            if(row.sensor_type=="MECHSEP"){
                this.dataDetails = row;
                this.showNearestMotorSeq = true;
                return;
            }
            this.dataDetails = [row];
            this.showChartDetails = true;
        },
       bagimg() {
            /* 获取当前页面的缩放比
                    若未设置zoom缩放比，则为默认100%，即1，原图大小
                */
            var zoom = parseInt(this.$refs.bigImage.style.zoom) || 100;
            /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
                    wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
                */
            zoom += event.wheelDelta / 12;
            /* 最小范围 和 最大范围 的图片缩放尺度 */
            // if (zoom >= 100 && zoom <250) {
                this.$refs.bigImage.style.zoom = zoom + "%";
            // }
            return false;
        },
        move(e){
            let odiv = e.target;        //获取目标元素
            //阻止默认事件的方法,如果不阻止默认事件onmouseup会无法触发
             e.preventDefault();
            //算出鼠标相对元素的位置
            let disX = (e.clientX - odiv.offsetLeft);
            let disY = (e.clientY - odiv.offsetTop);
            document.onmousemove = (e)=>{
                 //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                //因为img居中对齐，所以还要减去目标元素距离body的偏移量
                let left = e.clientX - disX - odiv.offsetLeft;
                let top = e.clientY - disY;
                //移动当前元素
                odiv.style.left = left + 'px';
                odiv.style.top = top + 'px';
            };
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
    },
}
</script>

<style lang='less' scoped>
.left-tree{
    background: #2C2E30;color:#fff;float:left;height:calc(100% - 160px);
    .el-input{
        text-align: center;
        padding:5px 0;
    }
    /deep/.el-input__inner{
        background-color: rgb(44,46,48);
    }
}
.site-tabs{
    position: relative;
    /deep/.el-tabs{
        width:220px;position: absolute;left:0;right:0;margin:auto;top:0;
    }
    /deep/.el-tabs__nav-wrap::after{
        height:0;
    }
    /deep/.el-tabs__active-bar{
        height: 0;;
    }
}
 .small-btn{
        width:80px;height:36px;background:rgb(32, 52, 49);border:solid 1px rgb(121,121,121);color:#fff;
        border-radius: 5px;
        cursor: pointer;
    }
    /deep/.left-tree .el-tree{
    background: #2C2E30;color:#fff;user-select: none;
}
/deep/.site-tabs-ul .el-tabs__item{
    font-size: 18px;;
}
/deep/.el-table tbody tr:hover>td{
    background: #3d3f44 !important;
}
/* 更改高亮颜色 */
/deep/.el-table__body tr.current-row>td.el-table__cell{
  background: #3d3f44 !important;
}
.table-btn{
    // color:#f00;
    // text-decoration: underline;
    // a{
    //     color:#f00;
    // }
}
.main-area{
    width:calc(100% - 300px);
    float: right;
}
/deep/.el-button+.el-button{
    margin-left:0;
}
.table-content{
    height:calc(100% - 100px);
    overflow: hidden;
    position: relative;
    .device-name,.point-name{
        width:150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /deep/.cell {
        white-space: nowrap;
    }
    /deep/.el-table{
        height: calc(100% - 50px) !important;
        overflow: hidden;
    }
    /deep/.el-table__body-wrapper{
        height: calc(100% - 50px);
        overflow-y: auto;
    }
}
/deep/.el-pagination {
    position: absolute;text-align: center;
    bottom: 0;left:0;right:0;margin:0 auto;
    .el-input__inner{
        background: #2C2E30;
        border:0;color:#fff;
    }
    .btn-prev,.btn-next{
        background: #2C2E30;
    }
    .el-pager li{
         background: #2C2E30;
    }
}
.tree-div{
    height:calc(100% - 40px)
}
/deep/.el-loading-text{color:#fff;}

.selected-border /deep/.el-input__inner {
  border: 1px solid #409EFF !important; /* 蓝色边框 */
  border-radius: 4px; /* 圆角 */
}
.alarmLevel_p {
    width: 50px;
    margin-left:35px
}
.sensor_type_p{
    width: 100px;
    margin-left:45px
}
.sensor_status{
    width: 13x;
    height: 13px;
    float: left;
    margin-left:20px;
    margin-top:4px;
}
/deep/.el-input__inner{
  color: #ffffff;
}
.status-container {
  display: flex;
  flex-direction: column;
  gap: 4px; /* 内部元素垂直间距 */
  align-items: center; /* 水平居中 */
}

.status-icon {
  width: 13px;
  height: 13px;
  margin-right: 4px;
}

.online-text {
  margin-bottom: 2px;
}
.online-text-alarmStatus {
  margin-bottom: 2px;
  width:50px
}
.metrics-info {
  display: flex;
  flex-wrap: wrap; /* 空间不足时自动换行 */
  gap: 8px; /* 指标项之间的间距 */
  justify-content: center; /* 水平居中 */
  width: 100%; /* 占满单元格宽度 */
  font-size:10px
}

.metric-item {
  display: flex;
  align-items: center;
  gap: 4px; /* 图标与文本间距 */
}

.metric-icon {
  width: 15px;
  height: 15px;
}
/* 新增：控制图标和文本在同一行 */
.status-header {
  display: flex; /* 水平排列 */
  align-items: center; /* 垂直居中对齐 */
  gap: 6px; /* 图标与文本之间的间距 */
}
// @keyframes intermittentShake {
//   /* 0-1秒：快速抖动 */
//   0%, 5%, 10%, 15% { transform: translateX(-3px); }
//   2.5%, 7.5%, 12.5%, 17.5% { transform: translateX(3px); }
//   /* 1-3秒：静止不动（暂停抖动） */
//   20% { transform: translateX(0); }

// }

// /* 应用动画的类 */
// .intermittent-shake {
//   /* 总周期3秒（1秒抖动 + 2秒静止），无限循环 */
//   animation: intermittentShake 3s cubic-bezier(.36,.07,.19,.97) infinite;
//   transform-origin: center;
// }
</style>



// WEBPACK FOOTER //
// src/view/site/site.vue